import { render, staticRenderFns } from "./assignTask.vue?vue&type=template&id=80e255c2&scoped=true"
import script from "./assignTask.vue?vue&type=script&lang=js"
export * from "./assignTask.vue?vue&type=script&lang=js"
import style0 from "./assignTask.vue?vue&type=style&index=0&id=80e255c2&prod&lang=less&scoped=true"
import style1 from "./assignTask.vue?vue&type=style&index=1&id=80e255c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e255c2",
  null
  
)

export default component.exports